module.exports = __webpack_public_path__ + "static/usecase_exchange2_profile@2x-9eeb0a1fe62ae2aaff5d01763598facd.png";